/* eslint-disable */
export const SET_ACTIVE_ITEM = '@navigation/SET_ACTIVE_ITEM';


// WEBPACK FOOTER //
// ./src/Modules/Navigation/constants.js